import {
    ALDER_LOGISK_FEILMELDING,
    ALDERSGRUPPE,
    ALDERSGRUPPE_5ARIG,
    MANED,
    UKEDAG,
    UKEDAG_MANED_FEILMELDING
} from '../../../ressurser/Konstanter'

/**
 * Denne funksjonen skjekker for logisk feil i filter. Den returnerer true dersom ett aldersgruppefilter er valgt.
 * @param filter Valgt filter <br/>
 * @param navn Navnet på nedtrekkslisten <br/>
 * @returns {boolean}
 * @public
 */
export function logiskKontrollFilter(filter, navn) {
    if (filter.filterETO) {
        let aldersgruppeIRadOgKolonner = false
        let aldersgruppe5arigIRadOgKolonner = false
        let ukedagerRadOgKolonner = false
        let manedRadOgKolonner = false
        for (const i in filter.raderOgKolonnerValgETO) {
            if (filter.raderOgKolonnerValgETO[i]) {
                if (filter.raderOgKolonnerValgETO[i].navn === ALDERSGRUPPE) {
                    aldersgruppeIRadOgKolonner = true
                } else if (filter.raderOgKolonnerValgETO[i].navn === ALDERSGRUPPE_5ARIG) {
                    aldersgruppe5arigIRadOgKolonner = true
                }
                if (filter.raderOgKolonnerValgETO[i].navn === MANED) {
                    manedRadOgKolonner = true
                } else if (filter.raderOgKolonnerValgETO[i].navn === UKEDAG) {
                    ukedagerRadOgKolonner = true
                }
            }
        }
        switch (navn) {
            case ALDERSGRUPPE:
                return filter.filterETO.person.femarigAlderIntervaller || aldersgruppe5arigIRadOgKolonner
            case ALDERSGRUPPE_5ARIG:
                return filter.filterETO.person.ssbAlderIntervaller || aldersgruppeIRadOgKolonner
            case MANED:
                return filter.filterETO.ulykke.ukedagtyper || ukedagerRadOgKolonner
            case UKEDAG:
                return filter.filterETO.ulykke.maneder || manedRadOgKolonner
            default:
                return false
        }
    } else {
        return false
    }
}

export function genererFeilmeldingFilter(navn) {
    switch (navn) {
        case ALDERSGRUPPE:
        case ALDERSGRUPPE_5ARIG:
            return ALDER_LOGISK_FEILMELDING
        case MANED:
        case UKEDAG:
            return UKEDAG_MANED_FEILMELDING
        default:
            return ''
    }
}
